import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["partNumbers", "partNumber", "quantity", "maximumQuantity", "isEnabled", "onChange", "updateTrolleyField", "prepareTrolleyRequestIfNeeded"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable jsx-a11y/no-onchange */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Select } from '@sainsburys-tech/bolt';
import { flatten } from '../../helpers';
import * as actions from '../../actions';
export var Quantity = function Quantity(_ref) {
  var partNumbers = _ref.partNumbers,
      partNumber = _ref.partNumber,
      quantity = _ref.quantity,
      maximumQuantity = _ref.maximumQuantity,
      isEnabled = _ref.isEnabled,
      onChange = _ref.onChange,
      updateTrolleyField = _ref.updateTrolleyField,
      prepareTrolleyRequestIfNeeded = _ref.prepareTrolleyRequestIfNeeded,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(quantity),
      _useState2 = _slicedToArray(_useState, 2),
      currentQuantity = _useState2[0],
      setQuantity = _useState2[1];

  useEffect(function () {
    var partNumberList = [].concat(_toConsumableArray(partNumbers), [partNumber]);
    partNumberList.forEach(function (currentPartNumber) {
      return prepareTrolleyRequestIfNeeded(currentPartNumber);
    });
  }, []);
  useEffect(function () {
    setQuantity(quantity);
  }, [quantity]);

  var updateQuantity = function updateQuantity(event) {
    onChange(event);
    var qty = parseInt(event.target.value, 10);
    setQuantity(qty);
    var partNumberList = [].concat(_toConsumableArray(partNumbers), [partNumber]);
    partNumberList.forEach(function (currentPartNumber) {
      return updateTrolleyField(currentPartNumber, actions.TROLLEY_FIELD_QUANTITY, qty);
    });
  };

  var options = Array(maximumQuantity).fill() // eslint-disable-next-line id-length
  .map(function (_, index) {
    var quantityIndex = (index + 1).toString();
    return {
      title: quantityIndex,
      value: quantityIndex
    };
  });
  return /*#__PURE__*/React.createElement(Select, _extends({
    name: "add-to-trolley-quantity",
    onChange: updateQuantity,
    disabled: !isEnabled,
    value: "".concat(currentQuantity),
    options: options,
    placeholder: null
  }, props));
};
Quantity.propTypes = {
  className: PropTypes.string,
  quantity: PropTypes.number,
  maximumQuantity: PropTypes.number,
  partNumber: PropTypes.string.isRequired,
  partNumbers: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  prepareTrolleyRequestIfNeeded: PropTypes.func,
  updateTrolleyField: PropTypes.func,
  isEnabled: PropTypes.bool
};
Quantity.defaultProps = {
  onChange: function onChange() {},
  maximumQuantity: 10,
  className: '',
  isEnabled: true
};
export var mapStateToProps = function mapStateToProps(state, props) {
  var trolley = flatten(state).trolley || {};
  var partNumbers = props.partNumbers || [];
  var quantity = trolley[props.partNumber] && trolley[props.partNumber].quantity || 0;
  return {
    quantity: quantity,
    partNumbers: partNumbers
  };
};
export default connect(mapStateToProps, _objectSpread({}, actions))(Quantity);